import axios from 'axios';
import { useEffect } from 'react';

import useLocales from 'src/hooks/useLocales';

import { AUTH0_API, REQUEST_ORIGIN_OVERRIDE } from 'src/config';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: AUTH0_API.domain,
});

export const useIdentityAxiosInterceptors = () => {
  const { currentLang } = useLocales();

  const errorInterceptor = async (error: any) =>
    Promise.reject((error.response && error.response.data) || 'Something went wrong');

  const requestInterceptor = (config: any) => {
    config.headers['Accept-Language'] = currentLang.value;
    if (REQUEST_ORIGIN_OVERRIDE) {
      config.headers['request-origin'] = REQUEST_ORIGIN_OVERRIDE;
    }
    return config;
  };

  useEffect(() => {
    const refreshInterceptor = axiosInstance.interceptors.response.use(
      (response) => response,
      errorInterceptor
    );
    const authInterceptor = axiosInstance.interceptors.request.use(requestInterceptor, (error) =>
      Promise.reject(error)
    );

    return () => {
      axiosInstance.interceptors.response.eject(refreshInterceptor);
      axiosInstance.interceptors.request.eject(authInterceptor);
    };
  }, [currentLang]);

  return axiosInstance;
};

export default axiosInstance;
